import "./App.css";
import React, { useState, useRef } from "react";
import MapSection from "./MapSection/MapSectionMain";
import SummarySection from "./SummarySection/SummarySectionMain";
import useCountryList from "./Data/useCountryList";
import CountryCoords from "./Data/CountryCoords";
import regionConfig from "./Config/region";
import UseMonthConfig from "./Config/month";

//size controls
const width = 1150;
const height = 720;
const margin = { top: 0, right: 0, bottom: 0, left: 0 };
const innerHeight = height - margin.top - margin.bottom;
const innerWidth = width - margin.left - margin.right;
const mapSectionWidth = innerWidth * 0.53;
const summarySectionWidth = innerWidth - mapSectionWidth;

function App() {
  //set region and get month data
  const region = "asiaPac";
  const period = {
    month: "October",
    year: 2022,
  };

  //DONT CHANGE VALUES BELOW THIS LINE

  //const newData = useData();
  const monthConfig = UseMonthConfig();
  const newCountryList = useCountryList();

  //states & refs
  const [map, setMap] = useState(null);
  const [zoomedCountry, setZoomedCountry] = useState(null);
  const iconsRef = useRef();
  const geoJsonRef = useRef();
  const mapBoxCoords = CountryCoords();

  //shortcircuit
  if (!newCountryList || !monthConfig.data) {
    return <p>waiting</p>;
  }

  //Initialise values (**key figures tbc**)
  const startingPosition = regionConfig(region).startingPosition;

  //Methods
  const getDescriptionFromCountry = (country) => {
    return monthConfig.trendCountries[country]
      ? monthConfig.trendCountries[country].content
      : null;
  };

  console.log(monthConfig)

  const setPositionDOMWork = (country) => {
    document.querySelector("#hover-tooltip").style.display = "none";
    iconsRef.current.remove();
    for (const layer in geoJsonRef.current._layers) {
      geoJsonRef.current._layers[layer].addTo(map);
      if (
        geoJsonRef.current._layers[layer].feature.properties.NAME === country
      ) {
        geoJsonRef.current._layers[layer].remove();
      }
    }
    map.flyTo(mapBoxCoords[country].centroid, mapBoxCoords[country].zoom, {
      animate: true,
      duration: 0.5,
    });
  };

  const setPositionHandler = (country, index) => {
    setZoomedCountry({
      country: country,
      content: getDescriptionFromCountry(index),
      link: monthConfig.trendCountries[index]
        ? monthConfig.trendCountries[index].slug
        : null,
    });
    setPositionDOMWork(country);
  };

  const resetPositionDOMWork = () => {
    map.flyTo(startingPosition.center, startingPosition.zoom, {
      animate: true,
      duration: 0.5,
    });
    for (const layer in geoJsonRef.current._layers) {
      geoJsonRef.current._layers[layer].addTo(map);
    }
    iconsRef.current.addTo(map);
  };

  const resetPosition = () => {
    setZoomedCountry(null);
    resetPositionDOMWork();
  };

  return (
    <div
      className="App"
      style={{
        display: "flex",
        width: innerWidth,
        border: "3px solid #12425e",
        height: innerHeight,
        position: "relative",
      }}
    >
      <MapSection
        region={region}
        startingPosition={startingPosition}
        setPositionHandler={setPositionHandler}
        zoomedCountry={zoomedCountry}
        resetPosition={resetPosition}
        mapBoxCoords={mapBoxCoords}
        width={mapSectionWidth}
        height={innerHeight}
        margin={margin}
        setMap={setMap}
        map={map}
        trendCountries={monthConfig.trendCountries}
        newData={monthConfig.data}
        iconsRef={iconsRef}
        geoJsonRef={geoJsonRef}
        period={period}
        newCountryList={newCountryList}
      />
      <SummarySection
        height={height}
        width={summarySectionWidth}
        map={map}
        keyEvents={monthConfig.keyEvents}
        period={period}
      />
    </div>
  );
}

export default App;
